import React, { createContext, useState, useContext, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';

import { DB } from '~/services/firebase';
import IMenu from '~/interfaces/IMenu';

interface MenusContextData {
  menus: IMenu[];
  loadMenus(id: string): Promise<void>;
  removeMenu(id: string): void;
  clearContext(): void;
  isInitialized: boolean;
}

const MenusContext = createContext<MenusContextData>({} as MenusContextData);

export const MenusProvider: React.FC = ({ children }) => {
  const [menus, setMenus] = useState<IMenu[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const clearContext = useCallback(() => {
    setMenus([]);
  }, []);

  const removeMenu = useCallback(
    (id: string) => {
      const filter = menus.filter(item => item.uid !== id);
      setMenus(filter);
    },
    [menus],
  );

  const loadMenus = useCallback(async (id: string) => {
    const q = query(collection(DB, 'menus'), where('company_id', '==', id));
    const querySnapshot = await getDocs(q);

    const items: IMenu[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as IMenu;

      items.push(parseItem);
    });

    setMenus(items);
    setIsInitialized(true);
  }, []);

  return (
    <MenusContext.Provider
      value={{ menus, loadMenus, clearContext, removeMenu, isInitialized }}
    >
      {children}
    </MenusContext.Provider>
  );
};

export function useMenus(): MenusContextData {
  const context = useContext(MenusContext);
  return context;
}
